import { analyticContentPipelineActions } from 'store/actions';
import { IAnalyticContentPipelineMeta } from 'store/actions/analytics/contentPipeline';
import { GenericResponse } from 'types/GenericResponse';
import { createAsyncReducer } from 'utils/Redux';

export default createAsyncReducer<
  IAnalyticContentPipelineMeta,
  GenericResponse
>(analyticContentPipelineActions);
